<template>
    <NuxtLoadingIndicator />
    <DynamicDialog />
    <FullPageLoader :show="impersonationLoader" />

    <AppConfirmDialog />

    <div>
        <SkipLink :inert="drawerIsOpen" />

        <AppSidebar />

        <main id="main-content" tabindex="-1" :inert="drawerIsOpen" class="nuxt-page-view" :class="{ mobile: isMobile }">
            <div class="w-full">
                <NuxtPage />
            </div>
        </main>
    </div>
</template>

<script setup lang="ts">
import DynamicDialog from 'primevue/dynamicdialog';
import AppConfirmDialog from '~/components/layout/AppConfirmDialog.vue';
import AppSidebar from '~/components/layout/Sidebar/AppSidebar.vue';
import SkipLink from '~/components/layout/SkipLink.vue';
import FullPageLoader from '~/components/shared/FullPageLoader.vue';
import { useMobileStore } from '~/stores/layout/mobile';
import { usePersonStore } from '~/stores/person';

const personStore = usePersonStore();
const { impersonationLoader } = storeToRefs(personStore);

const { isMobile } = useIsMobile();
const mobileStore = useMobileStore();
const drawerIsOpen = computed(() => isMobile.value && mobileStore.isMobileNavOpen);

// A member comes back from checkout to the page they LEFT, which is any page in this layout —
// not the dashboard, where the purchase triggers are mounted.
const { runUpgradeReturnNotice } = useUpgradeReturnNotice();
onMounted(() => void runUpgradeReturnNotice());
</script>

<style lang="scss" scoped>
.nuxt-page-view {
    @apply bg-zinc-50;
    margin-left: 280px;
    transition: margin-left 0.3s ease-in-out;

    &.mobile {
        margin-left: 0;
    }

    @media screen and (max-width: 1023.98px) {
        margin-left: 0;
    }
}
</style>
